import React, {Component} from 'react';
import Axios from 'axios';
import connect from "react-redux/es/connect/connect";

import moment from "moment";

class SharingSns extends Component {
    constructor (props) {
        super (props);

    }

    componentDidMount = async () =>{
        window.fbAsyncInit = function() {
            window.FB.init({
                appId      : 194126472010148,
                cookie     : true,  // enable cookies to allow the server to access
                // the session
                xfbml      : true,  // parse social plugins on this page
                version    : 'v7.0' // use version 2.1
            });
        };

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));


        window.Kakao.init('beede8b70b410c0bf58bad30725ac389');

    }

    statusChangeCallback(response) {
        console.log('statusChangeCallback');
        console.log(response);
        if (response.status === 'connected') {
            console.log("connected");
          this.testAPI();
        } else if (response.status === 'not_authorized') {
            console.log("Please log into this app.");
        } else {
            console.log("Please log into this facebook.");
        }
      }

    onClickSyndication = async () => {
        console.log("onClickSyndication");
    }

    checkLoginState() {
        window.FB.getLoginStatus(function(response) {
          this.statusChangeCallback(response);
        }.bind(this));
      }

    onClickShanringFacebook = async () => {
        // console.log("onClickShanringFacebook");
        // this.checkLoginState();
        // window.FB.login(this.checkLoginState());

        window.FB.ui({
            display: 'popup',
            method: 'share',
            href: 'https://developers.facebook.com/docs/',
          }, this.onFbPopup);

        // const popupUrl =`https://www.facebook.com/dialog/share?
        // app_id=145634995501895
        // &display=popup
        // &href=https%3A%2F%2Fyoutu.be%2FlqCr773EeBM
        // &redirect_uri=https%3A%2F%2Fdevelopers.facebook.com%2Ftools%2Fexplorer`;


        // window.open(popupUrl, `image-asset-preview-popup`, `width=700,height=680`);
    }

    onFbPopupResponse = (response) => {
        console.log("onFbPopupResponse ", response);
    }


    render = () => {
        return (
            <div>
                <div className={"modal fade show"} style={{display :"block"}}>
                    <div className={"modal-dialog modal-publish-video"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header"}>
                                <h5 className={"modal-title"}>{"Publish"}</h5>
                                {/* <button type={"button"} className={"close"}
                                    onClick={() => {
                                        this.onClickClose();
                                    }}>
                                    <span aria-hidden={"true"}><i className={"sprite sprite-cancel-lg"}></i></span>
                                </button> */}
                            </div>

                            <div className={"modal-body"}>                                
                                <div>
                                    <ul className={"sns"}>
                                        <li>
                                            <div>
                                                <button type="button"
                                                    onClick={this.onClickShanringFacebook}>
                                                    <div>
                                                        <span className={"icon"}>
                                                            <i className={"sprite sprite-facebook"}></i>
                                                        </span>
                                                        <strong>{"Facebook"}</strong>
                                                    </div>
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <button type="button"                                                    
                                                    onClick={this.onClickSyndication}>
                                                    <div>
                                                        <span className={"icon"}>
                                                            <i className={"sprite sprite-youtube"}></i>
                                                        </span>
                                                        <strong>{"Youtube"}</strong>
                                                    </div>
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <button type="button">
                                                    <div>
                                                        <span className={"icon"}>
                                                            <i className={"sprite sprite-twitter"}></i>
                                                        </span>
                                                        <strong>{"Twitter"}</strong>
                                                    </div>
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <button type="button">
                                                    <div>
                                                        <span className={"icon"}>
                                                            <i className={"sprite sprite-kakao"}></i>
                                                        </span>
                                                        <strong>{"Kakao"}</strong>
                                                    </div>
                                                </button>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <button type="button">
                                                    <div className={"icon"}>
                                                        <i className={"sprite sprite-instagram"}></i>
                                                    </div>
                                                    <strong>{"Instagram"}</strong>
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                {/* {this.state.result &&
                                    <div className={"url"}>
                                        <h6>{t(`common::label::${"URL"}`)} : </h6>
                                        <a href={this.state.result}
                                            className="emphasis"
                                            target="_blank"
                                            ref={ref => this.result = ref}>
                                            {this.state.result}
                                        </a>
                                        <button type="button"
                                            className="btn btn-outline-light btn-icon btn-copy"
                                            data-tooltip={t(`common::label::Copy`)}
                                            onClick={(e) => {
                                                this.onClickCopy(e, this.result);
                                            }}>
                                            <i class="sprite sprite-copy-text"></i>
                                        </button>
                                    </div>
                                } */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

let mapStateToProps = (state) => {
    return {
        state        
    };
};

SharingSns = connect(mapStateToProps)(SharingSns);
export default SharingSns;